import { Component, Vue } from 'vue-property-decorator'
import Call from '@/components/shared/call/Call.vue'

@Component({
  components: { Call }
})
export default class AddCall extends Vue {
}
